import { Wallet, Users, HandCoins, CalendarX, Banknote } from "lucide-react";
import { money } from "../lib/calc";

const cards = [
  { key: "totalPagar", label: "Total a Pagar", icon: Wallet, accent: "bg-slate-900 text-white", money: true },
  { key: "nominaBase", label: "Nómina Base", sub: "sin faltas ni préstamos", icon: Banknote, accent: "bg-white", money: true },
  { key: "workers", label: "Trabajadores", icon: Users, accent: "bg-white", money: false },
  { key: "totalPrestamos", label: "Total Préstamos", icon: HandCoins, accent: "bg-white", money: true },
  { key: "descuentoFaltas", label: "Descuento por Faltas", icon: CalendarX, accent: "bg-white", money: true },
];

export default function SummaryWidgets({ totals, workerCount }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="summary-widgets">
      {cards.map((c) => {
        const Icon = c.icon;
        const dark = c.accent.includes("slate-900");
        const value = c.key === "workers" ? workerCount : totals[c.key];
        return (
          <div key={c.key} className={`border border-slate-200 rounded-sm p-4 ${c.accent}`} data-testid={`widget-${c.key}`}>
            <div className="flex items-center justify-between">
              <span className={`text-xs uppercase tracking-wide ${dark ? "text-slate-300" : "text-slate-500"}`}>{c.label}</span>
              <Icon size={16} className={dark ? "text-slate-300" : "text-slate-400"} />
            </div>
            <div className={`font-mono-data text-2xl font-semibold mt-2 ${dark ? "text-white" : "text-slate-900"}`}>
              {c.money ? money(value) : value}
            </div>
            {c.sub && <div className="text-[10px] text-slate-400 mt-0.5">{c.sub}</div>}
          </div>
        );
      })}
    </div>
  );
}
